import React from "react";
import classes from './imgBlock.module.css';

const ImgBlock = (props) => {
    return (
        <div className={classes.imgBlock}>
            <h3>{props.imgblock.title}</h3>
            <img src={props.imgblock.img} alt="img-bg" />
            <div className={classes.img_bg}></div>
        </div>
    )
}

export default ImgBlock;